import { Button } from 'antd'
import React from 'react'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import './AddMedicationDescDialog.css'
import config from '../../../../config.json'

const AddMedicationDescDialog = ({
  isAddMedicationDescDialogVisible,
  setIsAddMedicationDescDialogVisible,
  plan,
}) => {
  const onCloseDialog = () => {
    setIsAddMedicationDescDialogVisible(false)
  }
  const renderDialogFooter = () => (
    <Button type="primary" onClick={onCloseDialog}>
      {$t('pages.getStarted.paymentPlans.dialogClose')}
    </Button>
  )
  const renderContent = () => (
    <p>
      {plan?.premium?.learn_more_text}{' '}
      <a
        className="payment-plan-learn-more-text"
        href={config.plansTermsURL}
        target="_blank"
        rel="noreferrer"
      >
        {$t('pages.getStarted.paymentPlans.termsOfUse')}
      </a>
      .
    </p>
  )
  return (
    <Dialog
      title={plan?.premium?.learn_more_title}
      isVisible={isAddMedicationDescDialogVisible}
      footerActions={renderDialogFooter()}
      onCancel={onCloseDialog}
    >
      {renderContent()}
    </Dialog>
  )
}

export default AddMedicationDescDialog
